import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, PlayCircleIcon, ShieldCheckIcon, ZapIcon, ActivityIcon, ClockIcon, UserCheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden bg-brand-navy" data-id="element-122">
      {/* Background Gradients & Glows */}
      <div className="absolute inset-0 bg-gradient-to-br from-brand-navy via-brand-charcoal to-brand-navy opacity-90 z-0" data-id="element-123" />
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-brand-laser-red/10 rounded-full blur-[120px] z-0 pointer-events-none" data-id="element-124" />
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-brand-teal/20 rounded-full blur-[100px] z-0 pointer-events-none" data-id="element-125" />

      <div className="container mx-auto px-4 relative z-10 py-20 md:py-32" data-id="element-126">
        <div className="max-w-4xl mx-auto text-center" data-id="element-127">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-128">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-teal/20 text-brand-teal border border-brand-teal/30 text-sm font-semibold tracking-wide mb-6 uppercase" data-id="element-129">
              Aspen Class IV Laser Therapy
            </span>
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight" data-id="element-130">
              Advanced Laser Therapy for{' '}
              <span className="text-brand-teal" data-id="element-131">Pain Relief</span>, Recovery,
              and Better Movement
            </h1>
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-lg md:text-xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-132">
            Experience the power of science-backed photobiomodulation. Our
            drug-free, surgery-free, non-invasive laser therapy supports rapid
            pain relief, enhanced circulation, deep tissue recovery, and
            restored mobility.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16" data-id="element-133">
            <button className="w-full sm:w-auto px-8 py-4 bg-brand-teal hover:bg-brand-teal-dark text-white rounded-lg font-semibold text-lg transition-all duration-300 flex items-center justify-center gap-2 shadow-lg shadow-brand-teal/25" data-id="element-134">
              <CalendarIcon className="w-5 h-5" data-id="element-135" />
              Schedule a Consultation
            </button>
            <a href="#video-section" className="w-full sm:w-auto px-8 py-4 bg-transparent hover:bg-white/5 text-white border-2 border-white/20 rounded-lg font-semibold text-lg transition-all duration-300 flex items-center justify-center gap-2" data-id="element-136">
              <PlayCircleIcon className="w-5 h-5" data-id="element-137" />
              Watch the Video
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="flex flex-wrap justify-center gap-3 md:gap-6" data-id="element-138">
            {[{
            icon: ShieldCheckIcon,
            text: 'Drug-Free'
          }, {
            icon: ActivityIcon,
            text: 'Surgery-Free'
          }, {
            icon: ZapIcon,
            text: 'Non-Invasive'
          }, {
            icon: ClockIcon,
            text: 'Fast Sessions'
          }, {
            icon: UserCheckIcon,
            text: 'Personalized Plans'
          }].map((chip, index) => <div key={index} className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2 text-sm text-gray-300 backdrop-blur-sm" data-id="element-139">
                <chip.icon className="w-4 h-4 text-brand-teal" data-id="element-140" />
                <span data-id="element-141">{chip.text}</span>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}